import React, { useRef, useState, useEffect } from "react";
import CrossHair from './obj/Crosshair';
import TwoViewer from './obj/2DViewer';
import ResizableGrid from './obj/ResizableGrid';
import FbxViewer from "./obj/FbxViewer";
import { config, rotate, zif ,menu,items,ZifData} from './config.js'
import GridViewer from "./zif/GridViewer";
import NavTree from "./zif/NavTree";
import { AppstoreOutlined,MailOutlined,DownOutlined } from '@ant-design/icons';
import {Button, Dropdown, message, Space,Radio } from 'antd';
import InfoDiv from './zif/InfoDiv'
import NaviGation from "./zif/NaviGation";
import Thumbnail from './zif/Thumbnail'
const MulfiViewer = ({ dataName, dataPath, setGrey }) => {
    const [res, setRes] = useState(null)
    const [coord, setCoord] = useState([0, 0, 0]);
    // 记录用户当前选取的坐标，coordinate为数组，依次记录X,Z,Y三个方向的坐标，每个方向坐标数值都归一化至[0 1]之间
    const [coordinate, setCoordinate] = useState([0.5, 0.5, 0.5]);  // 初始化为0.5
    // 记录当前坐标下，三维数据块显示在3个标准正交面上的slice，sliceSrcList为数组，依次记录YZ，XZ和XY三个方向
    const [sliceSrcList, setSliceSrcList] = useState(['./black.png', './black.png', './black.png']);  // 初始化为黑色图片
    // 保存3个slice渲染所需的canvas，canvasRefs为数组，依次记录XZ，XY和YZ三个方向slice对应的canvas
    const canvasRefs = [useRef(null), useRef(null), useRef(null)];  // 初始化为null
    // 当前选择的切面
    const [layer,setLayer]=useState('Coronal sections')
    // 当前树结构
    const [placement, SetPlacement] = useState('nucleusColour');
    // 当前的面
    const [TotalLevel, setTotalLevel] = useState(ZifData.Coronal.count);
    const [CurrentLevel, setCurrentLevel] = useState(ZifData.Coronal.count/2);
    useEffect (()=>{
        setTotalLevel(getlayer(layer))
        setCurrentLevel( Math.floor(getlayer(layer)/2))
    },[layer])
    const getlayer = (layer) => {
        if (layer === 'Coronal sections') {
        return ZifData.Coronal.count;
        }
        if (layer === 'Sagittal sections') {
        return ZifData.Sagittal.count;
        }
        if (layer === 'Horizontal sections') {
        return ZifData.Horizontal.count;
        }
        return 0; // 默认值或错误处理
    }
        
    const getnum = (n) => {
        if (n === 1) {
            return [1, 0]
        }
        if (n === 2) {
            return [2, 0]
        }
        if (n === 0) {
            return [1, 2]
        }
    }
    const getCoordinateIndexWithGivenConfig = (n) => {
        if (n === 0) {
            return 0
        }
        if (n === 1) {
            return 2
        }
        if (n === 2) {
            return 1
        }
    }
    function getRotatedIndices(rotateAngle) {
        // 根据旋转角度返回对应的索引
        switch (rotateAngle) {
            case 0:
                return [0, 1];
            case 90:
                return [1, 0];
            case -90:
                return [1, 0];
            case 180:
                return [0, 1];
            // 添加其他可能的旋转角度
            default:
                return [0, 1];
        }
    }
    const rotatedIndicesX = getRotatedIndices(rotate.x);
    const rotatedIndicesY = getRotatedIndices(rotate.y);
    const rotatedIndicesZ = getRotatedIndices(rotate.z);

    const MultiViewerConfig = [
        {
            Canvas: canvasRefs[config.x],  //XY0
            coordx: coord[getnum(config.x)[rotatedIndicesX[0]]],
            coordy: coord[getnum(config.x)[rotatedIndicesX[1]]],
            position_x: coordinate[getnum(config.x)[rotatedIndicesX[0]]],  //Y
            position_y: coordinate[getnum(config.x)[rotatedIndicesX[1]]],  //X
            setposition_x: (value) => setCoordinate(prevPosition => ({ ...prevPosition, [getnum(config.x)[rotatedIndicesX[0]]]: value })),
            setposition_y: (value) => setCoordinate(prevPosition => ({ ...prevPosition, [getnum(config.x)[rotatedIndicesX[1]]]: value })),
            src: sliceSrcList[config.x],
        },
        {
            Canvas: canvasRefs[config.y],  //XZ1
            coordx: coord[getnum(config.y)[rotatedIndicesX[0]]],
            coordy: coord[getnum(config.y)[rotatedIndicesX[1]]],
            position_x: coordinate[getnum(config.y)[rotatedIndicesY[0]]],  //X
            position_y: coordinate[getnum(config.y)[rotatedIndicesY[1]]],  //Z
            setposition_x: (value) => setCoordinate(prevPosition => ({ ...prevPosition, [getnum(config.y)[rotatedIndicesY[0]]]: value })),
            setposition_y: (value) => setCoordinate(prevPosition => ({ ...prevPosition, [getnum(config.y)[rotatedIndicesY[1]]]: value })),
            src: sliceSrcList[config.y],  //XZ
        },

        {
            Canvas: canvasRefs[config.z],  //YZ2
            coordx: coord[getnum(config.z)[rotatedIndicesZ[0]]],
            coordy: coord[getnum(config.z)[rotatedIndicesZ[1]]],
            position_x: coordinate[getnum(config.z)[rotatedIndicesZ[0]]],  //Y
            position_y: coordinate[getnum(config.z)[rotatedIndicesZ[1]]],  //Z
            setposition_x: (value) => setCoordinate(prevPosition => ({ ...prevPosition, [getnum(config.z)[rotatedIndicesZ[0]]]: value })),
            setposition_y: (value) => setCoordinate(prevPosition => ({ ...prevPosition, [getnum(config.z)[rotatedIndicesZ[1]]]: value })),
            src: sliceSrcList[config.z], //YZ
        },
        {
            percentageX: coordinate[0],  //X
            percentageY: coordinate[2],  //Y
            percentageZ: coordinate[1],  //Z
            setpercentageX: (value) => setCoordinate(prevPosition => ({ ...prevPosition, 0: value })),
            setpercentageY: (value) => setCoordinate(prevPosition => ({ ...prevPosition, 2: value })),
            setpercentageZ: (value) => setCoordinate(prevPosition => ({ ...prevPosition, 1: value })),
        },
    ];

    const getGrayValueFromPercentage = (Canvas, xPercentage, yPercentage) => {
        const canvas = Canvas.current;
        const ctx = canvas.getContext('2d');
        const canvasWidth = canvas.width;
        const canvasHeight = canvas.height;

        const xPosition = Math.floor(xPercentage * canvasWidth);
        const yPosition = Math.floor(yPercentage * canvasHeight);

        const pixelData = ctx.getImageData(xPosition, yPosition, 1, 1).data;
        const grayValue = (pixelData[0] + pixelData[1] + pixelData[2]) / 3; // 灰度值计算
        setGrey(grayValue)
    };

    // 当coordinate变化时，发送POST请求，然后获取3个2DViewer需要展示的新的slice图像的路径
    const [postRequestSentFlag, setPostRequestSentFlag] = useState(true);  // 节流阀，避免重复发送POST请求
    useEffect(() => {
        if (dataName && postRequestSentFlag) {
            setPostRequestSentFlag(false)
            const postData = {
                'file': dataPath + '/' + dataName,
                'layer': {
                    [config.x]: coordinate[getCoordinateIndexWithGivenConfig(config.x)],
                    [config.y]: 1-coordinate[getCoordinateIndexWithGivenConfig(config.y)],
                    [config.z]: coordinate[getCoordinateIndexWithGivenConfig(config.z)]
                },
                'rotate': {
                    [config.x]: rotate.x,
                    [config.y]: rotate.y,
                    [config.z]: rotate.z
                }
            };

            fetch(process.env.REACT_APP_PNG_URL + "/png", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(postData),
            })
                .then((response) => {
                    if (response.ok) {
                        return response.json();
                    }
                })
                .then(data => {
                    setSliceSrcList(prevImage => ({
                        ...prevImage,
                        [config.z]: `data:image/png;base64,${data.find(item => item[config.z])[config.z]}`,
                        [config.x]: `data:image/png;base64,${data.find(item => item[config.x])[config.x]}`,
                        [config.y]: `data:image/png;base64,${data.find(item => item[config.y])[config.y]}`
                    }));
                    setCoord(prevImage => ({
                        ...prevImage,
                        [config.z]: `${data.find(item => item[config.z])['coord']}`,
                        [config.x]: `${data.find(item => item[config.x])['coord']}`,
                        [config.y]: `${data.find(item => item[config.y])['coord']}`
                    }))
                    setRes(data[0]['res'])
                    setPostRequestSentFlag(true)
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        }
    }, [dataName, coordinate]);

    useEffect(() => {
        if (!zif) {
            getGrayValueFromPercentage(canvasRefs[config.x], coordinate[getnum(config.x)[0]], coordinate[getnum(config.x)[1]]);
        }

    }, [coordinate[getnum(config.x)[0]], coordinate[getnum(config.x)[1]]]);
    useEffect(() => {
        if (!zif) {
            getGrayValueFromPercentage(canvasRefs[config.z], coordinate[getnum(config.y)[0]], coordinate[getnum(config.y)[1]]);
        }
    }, [coordinate[getnum(config.y)[0]], coordinate[getnum(config.y)[1]]]);
    useEffect(() => {
        if (!zif) {
            getGrayValueFromPercentage(canvasRefs[config.z], coordinate[getnum(config.z)[0]], coordinate[getnum(config.z)[1]]);
        }
    }, [coordinate[getnum(config.z)[0]], coordinate[getnum(config.z)[1]]]);

    const btnClick = ({ key }) => {
        setLayer(key)
    };
    
    const placementChange = (e) => {
      SetPlacement(e.target.value);
    };
    if (zif) {
        return (
            <>
                {/* zif显示 */}
                <TwoViewer layer={layer} CurrentLevel={CurrentLevel} />
                {/* 网格 */}
                <GridViewer />
                <div id="nav_left">
                    {/* 切面选择 */}
                    <Dropdown menu={{ items,onClick:btnClick}}>
                        <Button>
                            <Space>{layer}<DownOutlined /></Space>
                        </Button>
                    </Dropdown>
                    <div id="nav_menu">
                    {/* 选择树 */}
                    <Radio.Group value={placement} onChange={placementChange}>
                    <Radio.Button value="nucleusColour">nucleusColour</Radio.Button>
                    <Radio.Button value="nucleusColour_swanson">nucleusColour_swanson</Radio.Button>
                    </Radio.Group>
                    {/* 树结构 */}
                    <NavTree json={placement} defaultSelectedKeys={[]} />
                    </div>
                    
                </div>
                <div id="nav_bottom">
                <InfoDiv />
                <NaviGation CurrentLevel={CurrentLevel} TotalLevel={TotalLevel}/>
                </div>
                <div id="nav_right">
                    <Thumbnail layer={layer} CurrentLevel={CurrentLevel} TotalLevel={TotalLevel}/>
                </div>
            </>
        );
        
        
    }
    else {
        return (
            <div className="windows-layout">
                {MultiViewerConfig.map((windowData, index) => (
                    <div key={index} className="window">
                        {index < 3 ? (
                            <>
                                <ResizableGrid res={res} coordx={windowData.coordx} coordy={windowData.coordy} />
                                <CrossHair
                                    Canvas={windowData.Canvas}
                                    position_x={windowData.position_x}
                                    position_y={windowData.position_y}
                                    setposition_x={windowData.setposition_x}
                                    setposition_y={windowData.setposition_y}
                                />
                                <TwoViewer Canvas={windowData.Canvas} src={windowData.src} rotate={rotate} zif={zif} ZifData={ZifData} />
                            </>
                        ) : (
                            <FbxViewer {...windowData} />
                        )}
                    </div>
                ))}
            </div>
        )
    }


}
export default MulfiViewer